import React from "react";
import { CategoryDetail, FunctionDetail, ProgramContainer } from "../../../entities/formTemplateDataType";
import { colour, spacing } from '../../../theme';
import { ErrorAlertComponent } from "../../odsCalloutBox/ErrorAlertComponent";
import { Heading1, Heading4 } from "../../../theme/headings";
import { CMAReportComponent } from "./CMAReportComponent";
import ReactModal from "react-modal";
import { InputText } from "primereact/inputtext";
import CMAUtils from "../../../utilities/CMAUtils";
import { TemplateStatus } from "../../../entities/Constants";
import { SpinnerComponent } from "../../../commonComponent/SpinnerComponent";


interface Props {
    programContainer: ProgramContainer;
    showCommentStatus: boolean;
    cmaRole: string;
    isCSD: boolean;
    callbackStepIndex?: (index: number, returnIndex?:number) => void;
    callback: (p: ProgramContainer) => void;
    callbackValueSaved: ()=>void;
}

interface State {
    showError: boolean;
    showReport: boolean;
    expandedFunctionHint: boolean[];
    expandedCategoryHint: boolean[];
    openApproverNote: boolean;
    openApprovePopup: boolean;
    openRejectPopup: boolean;
    openSuccessPopup: boolean;
    openErrorPopup: boolean;
    openCSDPopup: boolean;
    successMessage: string;
    isBusy: boolean
    showNameDialog: boolean;
    nameInput: string;
    nameError: string | null;
    isHovered: boolean;
}

export class CMADashboardComponent extends React.Component<Props, State> {
   functions
    constructor(props) {
        super(props);
        const currentTemplate = this.props.programContainer.Template;
        this.functions = this.props.programContainer.CMATemplateList.filter(t=>t.Name==currentTemplate)[0].Functions;
        this.state = {
            showError: false,
            showReport: false,
            expandedFunctionHint: this.functions.map(() => false),
            expandedCategoryHint: this.functions.map(() => false),
            openApproverNote: false,
            openApprovePopup: false,
            openRejectPopup: false,
            openSuccessPopup: false,
            openErrorPopup: false,
            openCSDPopup: false,
            successMessage: "",
            showNameDialog: false,
            nameInput: "",
            nameError: null,
            isHovered: false,
            isBusy: false,
        }
    }

    showChangeNameDialog = () => {
        this.setState({ showNameDialog: true, nameInput: this.props.programContainer.Entity.assessmentName || ""})
    }
 
    cancelNameChange = () => {
        this.setState({ showNameDialog: false, nameInput: "", nameError: null, showError: false});
    }
 
 
    submitNameChange = () => {
        const regex = /^[a-zA-Z0-9-_]+$/;
        const newName = this.state.nameInput;
   
        if (!newName) {
            this.setState({ nameError: 'Name cannot be empty', showError: true });
        }
       
        else if (newName.length > 100) {
            this.setState({ nameError: 'Limit 100 characters', showError: true });
        }
   
        /* else if (!regex.test(newName)) {
            this.setState({ nameError: 'Name must be alphanumeric (with hyphens and underscores permitted).', showError: true });
        } */
        else {
            this.setState({ showNameDialog: false, nameError: null, showError: false });
            this.props.programContainer.Entity.assessmentName = newName;
            CMAUtils.saveCMA(this.props.programContainer).then((success)=>{
                if(success){
                    this.props.callbackValueSaved();
                }
            });
        }
    }

    reviewPageIndex = 4;

    hintExpansion = (title: string, content: string, index: number, isFuncHeader: boolean) => {
        const isExpanded = isFuncHeader ? this.state.expandedFunctionHint[index] : this.state.expandedCategoryHint[index];

        return(
            <div className="ontario-hint-expander__container ontario-margin-bottom-0-!">
                <button className="ontario-hint-expander__button" id="hint-expander-button-id-1" aria-controls="hint-expander-content-1" aria-expanded="false" data-toggle="ontario-collapse"
                onClick={() => {
                    if (isFuncHeader) {
                        let newState = this.state.expandedFunctionHint;
                        newState[index] = !isExpanded;
                        this.setState({expandedFunctionHint: newState});
                    } else {
                        let newState = this.state.expandedCategoryHint;
                        newState[index] = !isExpanded;
                        this.setState({expandedCategoryHint: newState});
                    }
                }}>
                    {isExpanded && <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>}
                    {!isExpanded && <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>}
                    {title}
                </button>
                <div style={{display: isExpanded ? "block": "none"}} className="ontario-hint-expander__content" id="hint-expander-content-1" aria-labelledby="hint-expander-button-id-1" aria-hidden="true" data-toggle="ontario-expander-content">
                    <p style={{fontSize:"1rem"}}>{content}</p>
                </div>
            </div>
        );
    }
    functionContent = (f: FunctionDetail, index: number, sectionIndex: number) => {
        let htmlString = [];
        let categoryHtml = [];
        f.CategoryDetailList.forEach((c, index) =>{
            let resolvedComments = 0;
            let unresolvedComments = 0;
            if (this.props.programContainer.Entity.comments) {
                resolvedComments = this.props.programContainer.Entity.comments.reduce((acc, comment) => {
                    if (comment.Resolved && comment.func == f.FunctionName && comment.category == c.CategoryName) {
                        return acc+1;
                    } else return acc;
                }, 0);
                unresolvedComments = this.props.programContainer.Entity.comments.reduce((acc, comment) => {
                    if (!comment.Resolved && comment.func == f.FunctionName && comment.category == c.CategoryName) {
                        return acc+1;
                    } else return acc;
                }, 0)
            }
            categoryHtml.push(this.categoryContent(c, index, sectionIndex, unresolvedComments, resolvedComments));
            sectionIndex = sectionIndex + 1;
        });
        htmlString.push(
            <div className="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
                 <div className="ontario-table-div">
                    <table className=" ontario-table--full-container-width ontario-table--no-zebra-stripes" tabIndex={index}>
                        <caption style={{backgroundColor: colour.palette.white}}>{"Function " + String(index+1) + ": "}<span style={{fontWeight: "400"}}>{f.FunctionName}</span>
                            {this.hintExpansion(`What ${f.FunctionName} means?`, this.props.programContainer.FunctionNameList[index].description, index, true)}
                        </caption>
                        <thead>
                            <tr>
                                <th scope="col" colSpan={3}>
                                    Category
                                    {this.hintExpansion("What each category means?", this.props.programContainer.FunctionNameList[index].richText, index, false)}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {categoryHtml}
                        </tbody>
                    </table>
                 </div>
            </div>
        );
        return htmlString;
    }

    categoryContent = (c: CategoryDetail, index: number, sectionIndex: number, unresolvedComments: number, resolvedComments: number) => {
        let statusContent = [];
        let status = this.checkStatus(sectionIndex);

        if (status == "Not started yet") {
            statusContent.push(
                <span className="ontario-badge ontario-badge--neutral-light ontario-margin-right-48-!">NOT STARTED YET</span>
            );
        } else if (status == "Completed") {
            statusContent.push(
                <span className="ontario-badge ontario-badge--success-heavy ontario-margin-right-48-!">COMPLETED</span>
            );
        } else {
            statusContent.push(
                <span className="ontario-badge ontario-badge--default-heavy ontario-margin-right-48-!">IN PROGRESS</span>
            );
        }
        const highlighted = (this.props.showCommentStatus && unresolvedComments > 0) || (!this.props.showCommentStatus && this.state.showError && status != "Completed");


        return(
            <tr style={{borderLeft: highlighted ? ("4px solid " + colour.palette.systemRed) : "4px"}}>
                <th scope="rol" style={{width: "50%"}}>
                    <a className="ontario-h5" style={{textDecoration: "none"}}
                        onClick={(e) => this.props.callbackStepIndex(sectionIndex)}
                        >{String(index+1) + ": " + c.CategoryName}</a>
                </th>
                <td>
                    {statusContent}
                    {this.props.showCommentStatus && unresolvedComments > 0 && <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                        <use href="#ontario-icon-alert-error"></use>
                        <title>{unresolvedComments} unresolved comments, {resolvedComments} resolved comments</title>
                    </svg>}
                    {this.props.showCommentStatus && unresolvedComments == 0 && resolvedComments > 0 && <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                        <use href="#ontario-icon-alert-success"></use>
                        <title>{unresolvedComments} unresolved comments, {resolvedComments} resolved comments</title>
                    </svg>}
                </td>
            </tr>
        );
    }

    checkStatus = (sectionIndex: number) => {
        const currentSec = this.props.programContainer.ListOfFormSections[sectionIndex]
        if (currentSec) {
            const eleList = currentSec.ListOfFormSubSections[0]?.ListOfFormSectionElements;
            let completionCount = 0;
            eleList?.forEach((ele) => {
                if (ele.Value) completionCount = completionCount + 1;
            })
            if (completionCount == 0) {
                return "Not started yet";
            }
            else if (completionCount == eleList.length) {
                return "Completed";
            }
            else {
                return "In progress";
            }
        }
        return null;
    }

    render() {
        const p = this.props.programContainer;
        const unresolvedComments = !p.Entity.comments ? 0 : (p.Entity.comments.reduce((acc, c) => c.Resolved ? acc : (acc+1), 0));

        const { showError, nameInput, nameError, showNameDialog } = this.state;
        const errorStyle = showError ? { border: '1px solid red' } : {};
        let htmlString = [];
        let sectionIndex = this.reviewPageIndex+1;

        if (this.state.showReport) return <CMAReportComponent programContainer={p} 
            callback={() => this.setState({showReport: false})} 
            callbackValueSaved={()=>this.props.callbackValueSaved()}/>;

        htmlString.push(<SpinnerComponent isBusy={this.state.isBusy}/>)
        htmlString.push(
            <ErrorAlertComponent 
                bodyMsg={"Complete all sections before you submit your application."} 
                title={"Your questionnaire is incomplete"} 
                isEng={true} 
                Visible={this.state.showError}/>
        );

        htmlString.push(
            <Heading1 style={{
                fontFamily: 'Raleway, sans-serif',
                marginBottom: "15px",
                width: "70%",      
                borderBottom: "3px solid black",
                marginTop: "10px",
                marginLeft: "1px",
                }}>Dashboard Overview</Heading1>
            )
        
        htmlString.push(
            <div className="editable-name" style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{
                fontFamily: 'Raleway, sans-serif',
                fontSize: '1.0rem',
                fontWeight: 'bold' }}>
                {this.props.programContainer.Entity.assessmentName || this.props.programContainer.Entity.template}
            </span>  
                <a
                    href="#NameChange"
                    onClick={(e) => {
                        e.preventDefault();
                        this.showChangeNameDialog();
                    }}
                    style={{
                        fontFamily: 'Raleway, sans-serif',
                        fontSize: "1.0rem",
                        justifyContent: 'flex-start',
                        color: '#007bff',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        marginRight: '30%',
                        visibility: this.props.cmaRole == "C" && !this.props.isCSD ? "visible" : "hidden",
                     }}
                >
                    Change
                </a>
            </div>

                <div style={{
                    width: "70%",        
                    borderBottom: "1px solid #ccc",  
                    marginTop: "15px",
                    marginBottom: "15px",
                    marginLeft: "1px"
                }}>
                </div>


            <div className="fixed-id"
            style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "10px",
            }}
            >
           
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontFamily: 'Raleway, sans-serif', fontSize: '1.0rem', fontWeight: 'bold' }}>
                {"Assessment ID: " + this.props.programContainer.Entity.template}
                </span>
            </div>

            <div
                style={{
                width: "70%",
                borderBottom: "1px solid #ccc",
                marginTop: "15px",
                marginBottom: "9px",
                marginLeft: "1px",
                }}
            />
            </div>
            </div>
           
    );


    if (this.state.showNameDialog) {
        htmlString.push(
            <>
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1000
                }} onClick={this.cancelNameChange}></div>
   
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '0px',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                    zIndex: 1100,
                    width: '550px',
                    height: 'auto',
                    minHeight: '350px',
                    maxHeight: '400px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                }}>
                    <h3 style={{ fontFamily: 'Raleway', marginBottom: '10px', fontSize: '1.2rem', fontWeight: 'bold' }}>Change Assessment Name</h3>
   
                    <div style={{ width: '240px', height: '70px' }}>
                        <label style={{ fontFamily: 'Raleway, sans-serif', fontWeight: 'normal', fontSize: '15px', paddingBottom: '2%', }}>Current Name</label>
                        <InputText
                            value={this.props.programContainer.Entity.assessmentName || this.props.programContainer.Entity.template}
                            style={{
                                fontFamily: 'Open sans, sans-serif',
                                fontSize: '15px',
                                paddingTop: '10px',
                                paddingBottom: '10px',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '5px',
                                backgroundColor: '#f8f8f8',
                                width: '100%',
                                boxSizing: 'border-box',
                                height: '40px',
                                display: 'flex',
                                ...errorStyle
                            }}
                        />
                    </div>

                    <div style={{ width: '240px', height: '70px' }}>
                        <label style={{ fontFamily: 'Raleway, sans-serif', fontWeight: 'normal', fontSize: '15px', paddingBottom: '2%' }}>New Name</label>
                        <InputText
                            value={this.state.nameInput}
                            onChange={(e) => {
                                this.setState({
                                    nameInput: e.target.value,
                                    nameError: null,
                                    showError: false,
                                 });
                            }}
                            placeholder="Input here"
                            style={{
                                fontFamily: 'Open sans, sans-serif',
                                fontSize: '15px',
                                paddingTop: '10px',
                                paddingBottom: '10px',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '5px',
                                backgroundColor: '#f8f8f8',
                                width: '100%',
                                boxSizing: 'border-box',
                                height: '40px',
                                display: 'flex',
                                ...errorStyle
                            }}
                        />
                    </div>


                {nameError && (
                    <div style={{  fontFamily: 'Open sans, sans-serif', color: 'red', marginTop: '3px' }}>
                        {nameError}
                    </div>
                )}

   
                    <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        marginTop: '10px',
                        paddingTop: '20px',
                        width: '100%',
                        flexDirection: 'row',
                        paddingBottom: '5px'
                        }}>

                    <button className="ontario-button ontario-button--primary"
                        onClick={() => {this.submitNameChange()}}
                        style={{
                            fontFamily: 'Open sans, sans-serif',
                            fontSize: '0.9rem',
                            paddingLeft: '3px',
                            paddingRight: '3px',
                            width: 'auto',
                            maxWidth: '150px',
                            marginRight: '70px'
                        }}
                    > Save Changes </button>

                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            this.cancelNameChange();
                        }}
                        style={{
                            fontFamily: 'Open sans, sans-serif',
                            color: '#007bff',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            marginLeft: '60px',
                            fontSize: '0.9rem',
                            padding: '6px 12px',
                            marginBottom: '20px'
                         }}>
                            Cancel and return
                        </a>
                    </div>
                </div>
            </>
        );
    }  
        
        htmlString.push(<>
            <ErrorAlertComponent
                bodyMsg="Please make all requested edits before sending questionnaire for final review"
                title={`You have ${unresolvedComments} unresolved comments on your file`}
                dismissible={true}
                isEng={true}
                Visible={this.props.showCommentStatus && this.props.cmaRole == 'C' && unresolvedComments > 0}/>
                
                <button className="ontario-button ontario-button--primary" style={{display: (this.props.showCommentStatus && this.props.cmaRole == "C") || this.props.isCSD ? 'inline-block': 'none'}}
                onClick={()=> this.setState({openApproverNote: true})}>
                    View Approver Note
                </button>
        </>);


        this.functions.forEach((f, index) => {
            htmlString.push(this.functionContent(f, index, sectionIndex));
            sectionIndex = sectionIndex + f.CategoryDetailList.length;
        })
        // buttons
        htmlString.push(
            <button className="ontario-button ontario-button--primary"
                style={{display: this.props.showCommentStatus && this.props.cmaRole == 'A' ? 'none' : 'inline-block'}}
                onClick={() => {
                    // check if all questions are complete
                    let allComplete = true;
                    for (let i=sectionIndex; i < p.ListOfFormSections.length; i++ ) {
                        allComplete = allComplete && (this.checkStatus(i) == "Completed"); 
                    }
                    if (allComplete) {
                        this.setState({showError: false, showReport: true});
                    }
                    else this.setState({showError: true});
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                >View Report</button>
        );

        htmlString.push(
            <button className="ontario-button ontario-button--primary"
                style={{display: (this.props.showCommentStatus && this.props.cmaRole == 'A') || this.props.isCSD ? 'none' : 'inline-block'}}
                onClick={() => {
                    // check if all questions are complete
                    let allComplete = true;
                    for (let i=sectionIndex; i < p.ListOfFormSections.length; i++ ) {
                        allComplete = allComplete && (this.checkStatus(i) == "Completed"); 
                    }
                    if (allComplete) this.props.callbackStepIndex(this.reviewPageIndex);
                    else this.setState({showError: true});
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }}>Preview and Submit Questionnaire</button>
        );

        htmlString.push(
            <button className="ontario-button ontario-button--primary"
                style={{display: this.props.isCSD ? 'inline-block' : 'none'}}
                onClick={() => this.setState({openCSDPopup: true})}>
                Close Assessment
            </button>
        );

        htmlString.push(
            <button className="ontario-button ontario-button--primary"
                style={{display: this.props.showCommentStatus && this.props.cmaRole == 'A' ? 'inline-block' : 'none'}}
                onClick={() => this.setState({ openApprovePopup: true })}
                >Approve</button>
        );

        htmlString.push(
            <button className="ontario-button ontario-button--secondary"
                style={{display: this.props.showCommentStatus && this.props.cmaRole == 'A' ? 'inline-block' : 'none'}}
                onClick={() => this.setState({ openRejectPopup: true })}
                >Reject</button>
        );

        const gap = '50%';
        const trans = 'translate(-50%, -50%)';

        // View Approver Note popup (Champion POV)
        htmlString.push(
            <ReactModal 
            style={{ content: {position: "fixed", top: gap, left: gap, transform: trans, margin: 0,
                background: colour.palette.systemRedLight,
                borderTop: "8px solid " + colour.palette.systemRed,
                overflow: "auto",
                padding: `${spacing.spacing5}`,
                transition: "box-shadow 0.1s ease-in-out 0s"
            },
            overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }}
            isOpen={this.state.openApproverNote} 
            shouldCloseOnOverlayClick 
            onRequestClose={() => this.setState({ openApproverNote: false })}>
                <Heading4>Approver Note</Heading4>
                <p>
                    <strong>{p.Entity.approvalNotes}</strong>
                </p>
                <button className="ontario-button ontario-button--secondary ontario-margin-top-40-!" onClick={() => this.setState({ openApproverNote: false })}>Close</button>
            </ReactModal>
        );

        // Approve popup (Approver POV)
        htmlString.push(
            <ReactModal 
            style={{ content: {position: "fixed", top: gap, left: gap, transform: trans, margin: 0,
                background: colour.palette.systemLightGreen,
                borderTop: "8px solid " + colour.palette.systemGreen,
                overflow: "auto",
                padding: `${spacing.spacing5}`,
                transition: "box-shadow 0.1s ease-in-out 0s"
            },
            overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }}
            isOpen={this.state.openApprovePopup} 
            shouldCloseOnOverlayClick 
            onRequestClose={() => this.setState({ openApprovePopup: false })}>
                <Heading4>Approve</Heading4>
                
                <strong>Before sending final confirmation you can review your comments and choose the best option for approval</strong>
                <ul>
                    <li>Please note that after approval champion will no longer be able to make any adjustments to the assessment.</li>
                </ul>
                <label className="ontario-label" htmlFor="approver-note-input">
                    Approver's note <span className="ontario-label__flag">(optional)</span>
                </label>
                <textarea 
                    value={p.Entity.approvalNotes} 
                    className="ontario-input ontario-textarea" 
                    name="approver-note-input" 
                    id="approver-note-input" 
                    placeholder="Adding a note.............."
                    onChange={(e) => {
                        p.Entity.approvalNotes = e.target.value;
                        this.props.callback(p);
                        }}/>

                <button className="ontario-button ontario-button--primary ontario-margin-top-40-!" 
                    onClick={() => {
                        this.setState({isBusy: true});
                        CMAUtils.saveCMA(p, TemplateStatus.SUBMITTED).then(sendSubmit => {
                            if (sendSubmit) {
                                this.props.callbackValueSaved();
                                this.setState({isBusy: false, openApprovePopup: false, openSuccessPopup: true, successMessage: "Assessment was submitted successfully."})
                            } else {
                                this.setState({isBusy: false, openApprovePopup: false, openErrorPopup: true})
                            }
                        })
                    }}>
                    Approve and retain comments</button>
                <button 
                    className="ontario-button ontario-button--secondary ontario-margin-top-40-!" 
                    onClick={() => {
                        p.Entity.comments = null;
                        this.setState({isBusy: true});
                        CMAUtils.saveCMA(p, TemplateStatus.SUBMITTED).then(sendSubmit => {
                            if (sendSubmit) {
                                this.props.callbackValueSaved();
                                this.setState({isBusy: false, openApprovePopup: false, openSuccessPopup: true, successMessage: "Assessment was submitted successfully."})
                            } else {
                                this.setState({isBusy: false, openApprovePopup: false, openErrorPopup: true})
                            }
                        });
                    }}>
                    Approve without comments
                </button>
                <button className="ontario-button ontario-button--tertiary ontario-margin-top-40-!" onClick={() => this.setState({openApprovePopup: false})}>Cancel</button>
            </ReactModal>
        );

        // Reject popup (Approver POV)
        htmlString.push(
            <ReactModal 
            style={{ content: {position: "fixed", top: gap, left: gap, transform: trans, margin: 0,
                background: colour.palette.systemRedLight,
                borderTop: "8px solid " + colour.palette.systemRed,
                overflow: "auto",
                padding: `${spacing.spacing5}`,
                transition: "box-shadow 0.1s ease-in-out 0s"
            },
            overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }}
            isOpen={this.state.openRejectPopup} 
            shouldCloseOnOverlayClick 
            onRequestClose={() => this.setState({ openRejectPopup: false })}>
                <Heading4>Return for revision</Heading4>
                
                <strong>Before returning this assessment please provide overall comment for the Champion</strong>
                <ul>
                    <li>Provide overall reason why your are sending for revision</li>
                    <li>Give more details or feedback if needed</li>
                    <li>Reject with no comment if needed</li>
                </ul>
                <label className="ontario-label" htmlFor="approver-note-input">
                    Approver's note <span className="ontario-label__flag">(optional)</span>
                </label>
                <textarea 
                    value={p.Entity.approvalNotes} 
                    className="ontario-input ontario-textarea" 
                    name="approver-note-input" 
                    id="approver-note-input" 
                    placeholder="Adding a note.............."
                    onChange={(e) => {
                        p.Entity.approvalNotes = e.target.value;
                        this.props.callback(p);
                    }}/>

                <button className="ontario-button ontario-button--primary ontario-margin-top-40-!" 
                    onClick={() => {
                        this.setState({isBusy: true});
                        CMAUtils.saveCMA(p, TemplateStatus.REVISION)
                            .then(submission => {
                                if (submission) {
                                    this.props.callbackValueSaved();
                                    this.setState({isBusy: false, openRejectPopup: false, openSuccessPopup: true, successMessage: "Assessment was returned for revision successfully."})
                                } else {
                                    this.setState({isBusy: false, openRejectPopup: false, openErrorPopup: true})
                                }
                            });
                        }}>
                    Return for revision</button>
                <button className="ontario-button ontario-button--secondary ontario-margin-top-40-!" onClick={() => this.setState({openRejectPopup: false})}>Cancel</button>
            </ReactModal>
        );

        // Success popup
        htmlString.push(
            <ReactModal 
            style={{ content: {position: "fixed", top: gap, left: gap, transform: trans, margin: 0,
                background: colour.palette.systemLightGreen,
                borderTop: "8px solid " + colour.palette.systemGreen,
                overflow: "auto",
                padding: `${spacing.spacing5}`,
                transition: "box-shadow 0.1s ease-in-out 0s"
            },
            overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }}
            isOpen={this.state.openSuccessPopup} >
                <Heading4>Success</Heading4>
                
                <p>{this.state.successMessage}</p>
                <button className="ontario-button ontario-button--primary ontario-margin-top-40-!" onClick={() => this.props.callbackStepIndex(2)}>Close</button>
            </ReactModal>
        );

        // Error popup
        htmlString.push(
            <ReactModal 
            style={{ content: {position: "fixed", top: gap, left: gap, transform: trans, margin: 0,
                background: colour.palette.systemRedLight,
                borderTop: "8px solid " + colour.palette.systemRed,
                overflow: "auto",
                padding: `${spacing.spacing5}`,
                transition: "box-shadow 0.1s ease-in-out 0s"
            },
            overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }}
            isOpen={this.state.openErrorPopup} 
            shouldCloseOnOverlayClick 
            onRequestClose={() => this.setState({ openErrorPopup: false })}>
                <Heading4>There is an error</Heading4>
                
                <p>There was an error. Please try again.</p>
                <button className="ontario-button ontario-button--primary ontario-margin-top-40-!" onClick={() => this.setState({openErrorPopup: false})}>Close</button>
            </ReactModal>
        );

        // CSD popup
        htmlString.push(
            <ReactModal 
            style={{ content: {position: "fixed", top: gap, left: gap, transform: trans, margin: 0,
                background: colour.palette.systemLightGreen,
                borderTop: "8px solid " + colour.palette.systemGreen,
                overflow: "auto",
                padding: `${spacing.spacing5}`,
                transition: "box-shadow 0.1s ease-in-out 0s"
            },
            overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }}
            isOpen={this.state.openCSDPopup}
            shouldCloseOnOverlayClick 
            onRequestClose={() => this.setState({ openCSDPopup: false })}>                
                <label className="ontario-label" htmlFor="csd-note-input">
                    CSD Note <span className="ontario-label__flag">(optional)</span>
                </label>
                <textarea 
                    value={p.Entity.csdNotes} 
                    className="ontario-input ontario-textarea" 
                    name="csd-note-input" 
                    id="csd-note-input" 
                    placeholder="Adding a note.............."
                    onChange={(e) => {
                        p.Entity.csdNotes = e.target.value;
                        this.props.callback(p);
                        }}
                    />

                <button className="ontario-button ontario-button--primary ontario-margin-top-40-!" 
                    onClick={() => {
                        this.setState({isBusy: true});
                        CMAUtils.saveCMA(p, TemplateStatus.COMPLETED).then(sendSubmit => {
                            if (sendSubmit) {
                                this.props.callbackValueSaved();
                                this.setState({isBusy: false, openCSDPopup: false, openSuccessPopup: true, successMessage: "Assessment has been marked completed."});
                            } else {
                                this.setState({isBusy: false, openCSDPopup: false, openErrorPopup: true})
                            }
                        })
                    }}>
                    Mark Completed
                </button>
            </ReactModal>
        );
        return htmlString;
    }
}